import { ProgressPreferences, SummaryItem } from 'src/api/learningSessions/types';

export const FULLY_GROWN_LEVEL = 6;

export type SummaryGroups = {
  stillLearning: SummaryItem[];
  markedAsKnown: SummaryItem[];
  justLearned: SummaryItem[];
  reviewed: SummaryItem[];
};

/**
 * Words already fully grown when the session started were reviewed; words that became
 * fully grown during it were just learned. Words marked as already known ("I already
 * know this") get their own group.
 */
export const groupSummaryItems = (
  summaryItems: SummaryItem[],
  progressPreferences: { [learnableId: number]: ProgressPreferences },
): SummaryGroups =>
  summaryItems.reduce<SummaryGroups>(
    (groups, item) => {
      if (progressPreferences[item.learnableId]?.ignored) {
        groups.markedAsKnown.push(item);
      } else if ((item.growthLevelBefore ?? 0) >= FULLY_GROWN_LEVEL) {
        groups.reviewed.push(item);
      } else if (item.growthLevel >= FULLY_GROWN_LEVEL) {
        groups.justLearned.push(item);
      } else {
        groups.stillLearning.push(item);
      }
      return groups;
    },
    { stillLearning: [], markedAsKnown: [], justLearned: [], reviewed: [] },
  );
